import { Lookup } from "./lookup.model";

export class MappingGeofencedZoneGroup {
  id: string;
  name: string;
  zoneBoundary: string;
  mappingGroupId: string;
  organizationLevelId: string;
}

export class ZoneLookup extends Lookup {
  isSelected?: boolean;
  mappingGroupId?: string;
  organizationLevelId?: string;
  zoneBoundary?: string;
  isFocused?: boolean;
}
